import { FC } from 'react';

import { ONE_RESPONSE_PRICE } from 'utils/vrCampaign';

import { Banner, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    description: 'VrCampaignBuilderPage.presets.description',
};

export const OneReponsePriceBanner: FC = () => {
    const trls = useTrls();

    return (
        <Banner
            stretched
            showClose={false}
            style="accent-secondary"
            content={<Text typography="paragraph-2-regular">{trls(TrlKeys.description, [ONE_RESPONSE_PRICE])}</Text>}
        />
    );
};
